import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

import StatusMessages from '../../../components/StatusMessages';
import BlankState from '../../../components/BlankState';
import Page from '../../../components/Page';
import DataTable from '../../../components/DataTable';
import { TabHolder, Tab } from '../../../components/Tabs';
import Modal from '../../../components/Modal';

import BrokerAdminForm from './BrokerAdminForm';
import BrokerAgencyForm from './BrokerAgencyForm';
import BrokerPartnershipsForm from './BrokerPatnershipsForm';

import {
  listFilteredBrokers,
  listBrokerAdmins,
  listPartners
} from '../../../actions/brokers';

class BrokersAgencies extends Component {
  constructor(props) {
    super(props);
    const { user } = this.props;
    this.state = {
      user: {
        email: '',
        first_name: '',
        last_name: '',
        other_names: '',
        phone: '',
        username: '',
        intermediary: ''
      },
      broker: {},
      agencies: [],
      companies: [],
      broker_partners: [],
      brokers_loading: true,
      active_broker: {},
      active_broker_admin: {},
      filter: {
        insurer: user ? user.userInfo.insurer : '',
        intermediary_type: ''
      }
    };
  }

  componentDidMount() {
    const { listBrokerAdmins, listPartners } = this.props;

    listBrokerAdmins(this.state.filter);
    listPartners(this.state.filter);
    this.filterBrokers();
  }

  editBroker(broker) {
    this.setState({
      active_broker: broker
    });
  }
  filterBrokers() {
    this.props.listFilteredBrokers(this.state.filter);
  }
  resetRatesForm = () => {
    this.setState({
      active_broker: {}
    });
  };

  onChange = e => {
    const { name, value } = e.target;
    this.setState(
      {
        filter: {
          ...this.state.filter,
          [name]: value
        }
      },
      () => {
        this.filterBrokers();
      }
    );
  };
  editBrokerAdmin(broker_admin) {
    this.setState({
      active_broker_admin: broker_admin
    });
  }

  editBrokerPartners(broker_partner) {
    this.setState({
      active_broker_partner: broker_partner
    });
  }

  render() {
    const menuItems = [
      { id: 'broker-agencies', name: 'Broker Agencies', active: true },
      { id: 'broker-admins', name: 'Broker Admins' },
      { id: 'broker-partnerships', name: 'Broker Partnerships' },
      { id: 'add-broker', name: 'Add Broker Agency' },
      { id: 'add-broker-admin', name: 'Add Broker Admin' },
      { id: 'add-broker-partnerships', name: 'Add Broker Partnerships' }
    ];

    let { active_broker } = this.state;

    const { brokers } = this.props;
    const brokerType = [
      { key: 'BROKERAGE', value: 'BROKERAGE', text: 'BROKERAGE' },
      { key: 'AGENCY', value: 'AGENCY', text: 'AGENCY' }
    ];
    return (
      <Page isAdminPage={true} pageTitle="Brokers/Agencies">
        <div className="clearfix">
          <TabHolder menuItems={menuItems}>
            <Tab menuId={menuItems[0].id} isActive={true}>
              {brokers.errorrBrokersList ? (
                <StatusMessages
                  type="error"
                  message={brokers.errorMessageBrokersList[0]}
                />
              ) : null}
              <div className="row">
                <div className="col-md-4">
                  <select
                    className="form-control"
                    name="intermediary_type"
                    onChange={this.onChange}
                  >
                    <option value="">Intermediary Type</option>
                    {brokerType.map((type, index) => {
                      return (
                        <option key={index} value={type.value}>
                          {type.text}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              {brokers.filteredBrokers.length > 0 ? (
                <DataTable
                  tableId="brokers-table"
                  columnTitles={[
                    'Name',
                    'Postal Address',
                    'Email',
                    'Helpline',
                    'Actions'
                  ]}
                >
                  {brokers.filteredBrokers.map((broker, index) => {
                    return (
                      <tr key={index}>
                        <td>{broker.name}</td>
                        <td style={{ width: '20%' }}>
                          {broker.postal_address || '-'}
                        </td>
                        <td>{broker.email}</td>
                        <td>{broker.phone}</td>
                        <td>
                          <button className="btn btn-danger btn-sm">
                            {true ? 'De-Activate' : 'Activate'}
                          </button>
                          <button
                            className="btn btn-warning btn-sm"
                            data-toggle="modal"
                            data-target=".edit-broker-modal"
                            onClick={() => {
                              this.editBroker(broker);
                            }}
                          >
                            Edit
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </DataTable>
              ) : (
                <BlankState
                  data={brokers.filteredBrokers}
                  dataName="Brokers"
                  isDataLoading={brokers.loadingFilteredBrokers}
                />
              )}

              <Modal
                title="Edit Broker"
                className="edit-broker-modal"
                closable={true}
              >
                <BrokerAgencyForm broker={active_broker} />
              </Modal>
            </Tab>

            <Tab menuId={menuItems[1].id}>
              {brokers.broker_admins.length > 0 ? (
                <DataTable
                  tableId="brokers-admin-table"
                  columnTitles={[
                    'Name',
                    'Email',
                    'Phone Number',
                    'Brokerage',
                    'Joined',
                    'Actions'
                  ]}
                >
                  {brokers.broker_admins.map((broker_admin, index) => {
                    const { user, intermediary_name } = broker_admin;

                    return (
                      <tr key={index}>
                        <td>{`${user.first_name} ${user.last_name} ${
                          user.other_names
                        }`}</td>
                        <td>{user.email}</td>
                        <td>{user.phone}</td>
                        <td>{intermediary_name}</td>
                        <td>
                          {moment(user.date_joined).format('MMM Do, YYYY')}
                        </td>
                        <td>
                          -
                          {/* <button
                                                        data-toggle="modal" 
                                                        data-target=".edit-admin-modal"
                                                        className="btn btn-warning btn-sm"
                                                        onClick={ ()=>{ this.editBrokerAdmin(broker_admin) }}>

                                                        Edit
                                                    </button> */}
                        </td>
                      </tr>
                    );
                  })}
                </DataTable>
              ) : (
                <BlankState
                  data={brokers.broker_admins}
                  dataName="Broker Admins"
                  isDataLoading={brokers.broker_admins_loading}
                />
              )}
              <Modal
                title="Edit Broker Admin"
                className="edit-admin-modal"
                closable={true}
              >
                <BrokerAgencyForm brokers={brokers.brokers} />
              </Modal>
            </Tab>
            <Tab menuId={menuItems[2].id}>
              {brokers.partners.length > 0 ? (
                <DataTable
                  tableId="brokers-partnerships-table"
                  columnTitles={[
                    'Intermediary Name',
                    'Premium Deposit',
                    'Credit Period',
                    'Credit Balance',
                    'Commission Rate(%)',
                    'Actions'
                  ]}
                >
                  {brokers.partners.map((broker_partner, index) => {
                    return (
                      <tr key={index}>
                        <td>{broker_partner.intermediary_name}</td>
                        <td>{broker_partner.credit_line}</td>
                        <td>{broker_partner.credit_period}</td>
                        <td>{broker_partner.credit_balance}</td>
                        <td>{broker_partner.commission_rate}</td>
                        <td>
                          <button
                            className="btn btn-warning btn-sm"
                            data-toggle="modal"
                            data-target=".edit-broker-modal"
                            onClick={() => {
                              this.editBroker(broker_partner);
                            }}
                          >
                            Edit
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </DataTable>
              ) : (
                <BlankState
                  data={brokers.partners}
                  dataName="Brokers"
                  isDataLoading={brokers.brokers_loading}
                />
              )}

              <Modal
                title="Edit Broker"
                className="edit-broker-modal"
                closable={true}
              >
                <BrokerPartnershipsForm
                  brokers={brokers.partners}
                  broker={active_broker}
                />
              </Modal>
            </Tab>
            <Tab menuId={menuItems[3].id}>
              <div className="col-sm-8 col-md-7">
                <BrokerAgencyForm brokers={brokers.brokers} />
              </div>
            </Tab>

            <Tab menuId={menuItems[4].id}>
              <div className="col-sm-8 col-md-7">
                <BrokerAdminForm brokers={brokers.brokers} />
              </div>
            </Tab>
            <Tab menuId={menuItems[5].id}>
              <div className="col-sm-8 col-md-7">
                <BrokerPartnershipsForm brokers={brokers.brokers} />
              </div>
            </Tab>
          </TabHolder>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  brokers: state.brokers,
  insurers: state.insurers
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { listFilteredBrokers, listBrokerAdmins, listPartners },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BrokersAgencies);



// WEBPACK FOOTER //
// ./src/pages/dashboard/agents/BrokersAgencies.jsx